import { useMutation } from '@tanstack/react-query';
import { apiFetch } from '@/lib/apiClient';

/**
 * D43b Phase 4 — redeems a server-minted Learn More view token.
 *
 * The token is never minted client-side — it rides along on the payload
 * that already carries the Learn More affordance (a restaurant summary's
 * cuisineTypes entry, or a quiz question/answer). This mutation fires once,
 * when a member actually opens the Learn More panel; it must never block or
 * fail the panel opening, since it's a gamification side effect of an
 * action the member already completed by tapping the chip.
 */
export interface LearnMoreRedemptionResult {
  redeemed: boolean;
}

export function useRedeemLearnMoreView() {
  return useMutation({
    mutationFn: (token: string) =>
      apiFetch<LearnMoreRedemptionResult>('/learn-more/redeem/', {
        method: 'POST',
        body: { token },
      }),
  });
}
